import EventBus from '../../../../shared/js/wirebox/event-bus'
import jQuery from 'jquery'
import '../../../../shared/js/components/form-validation'
import '../../../../shared/js/wirebox/utilities/get-hidden-input'

class DiscountForm {
    
    /**
     * Construct component
     * @param form
    */
    constructor(form) {
        
        /**
         * Form jQuery object
         * @type {object}
        */
        this.form = form
        
        /**
         * Code input jQuery object
         * @type {object}
        */
        this.codeInput = jQuery('#discount_code')
        
        /**
         * Content container jQuery object
         * @type {object}
        */
        this.contentContainer = jQuery(this.form.data('content'))
        
        /**
         * Discount label jQuery object
         * @type {object}
        */
        this.discountLabel = this.contentContainer.find('.discount-label')
        
        /**
         * Fieldset jQuery object
         * @type {object}
        */
        this.fieldset = this.form.find('fieldset')
        
        /**
         * Original price
         * @type {float}
        */
        this.price = parseFloat(this.form.data('price'))
        
        /**
         * Target form jQuery object
         * @type {object}
        */
        this.targetForm = jQuery(this.form.data('target'))
        
        this.bindEvents()
        
    }
    
    /**
     * Stripe JS loaded
    */
    stripeJsLoaded() {
        
        //Force submit form if discount value is already present
        const value = this.codeInput.val()
        if (value) {
            this.form.submit()
        }
        
    }
    
    /**
     * Handle successful form submit
     * @param event
     * @param params
    */
    formSuccess(event, {response}) {
        
        //Show Discount content within label
        this.discountLabel.text(response.label)
        
        //Show container
        this.contentContainer.fadeIn()
        
        //Disable form
        this.fieldset.prop('disabled', true)
        
        //Apply Discount code to target form
        this.handleTargetInput((input) => {
            input.val(this.codeInput.val())
        })
        
        //Determine new price
        const newPrice = response.amount_off ? (this.price - (response.amount_off / 100)).toFixed(2) : (this.price * ((100 - response.percent_off) / 100)).toFixed(2)
        
        //Update price events
        this.handleDiscountPrice(newPrice)
        
    }
    
    /**
     * Remove discount
    */
    removeDiscount() {
        
        //Hide container
        this.contentContainer.stop().hide()
        
        //Clear input
        this.codeInput.val('')
        
        //Enable form
        this.fieldset.prop('disabled', false)
        
        //Clear code input from target form
        this.handleTargetInput((input) => {
            input.remove()
        })
        
        //Handle discount price
        this.handleDiscountPrice(this.price)
        
    }
    
    /**
     * Handle target input
     * @param callback
    */
    handleTargetInput(callback) {
        EventBus.publish('get-hidden-input', {
            form: this.targetForm,
            name: 'code',
            callback: callback
        })
    }
    
    /**
     * Handle discount price
     * @param price
    */
    handleDiscountPrice(price) {
        
        //Broadcast addition event
        EventBus.publish('discount.price', price)
        
        //Trigger event on target form
        this.targetForm.trigger('discount.price', price)
        
    }
    
    /**
     * Bind events
    */
    bindEvents() {
        
        //Form success
        this.form.on('form-ajax-success', this.formSuccess.bind(this))
        
        //Bind Stripe JS loaded event
        EventBus.subscribe('stripe.js.loaded', this.stripeJsLoaded.bind(this))
        
        //Discount remove button click
        jQuery(document).on('click', '.discount-remove-btn', this.removeDiscount.bind(this))
        
    }
    
}

EventBus.subscribe('init-modules',  () => {
    
    const form = jQuery('#discount-form')
    
    if (form.length > 0) {
        new DiscountForm(form)
    }
    
})

export default DiscountForm